import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Loader2 } from 'lucide-react';
import { matchSorter } from 'match-sorter';
import mainImg from '../img/oms_logo-04 copy.png';
import omsIconImg from '../img/1.png';
import ecomIconImg from '../img/2.png';
import financeIconImg from '../img/3.png';
import realEstateIconImg from '../img/4.png';
import sportsIconImg from '../img/5.png';

const categoryData = [
  {
    name: '100billion Tech',
    icon: omsIconImg,
    description: 'Organization Management System.',
    adminLink: 'https://admin.100billiontech.com/',
    staffLink: 'https://team.100billiontech.com/',
  },
  {
    name: 'Ecommerce',
    icon: ecomIconImg,
    description: 'Sell Products Online Easily.',
    adminLink: 'https://business.100billionoms.com/',
    staffLink: '#',
  },
  {
    name: 'Finance',
    icon: financeIconImg,
    description: 'Manage Accounts & Expenses.',
    adminLink: 'https://finance.100billiontech.com',
    staffLink: 'https://finteam.100billiontech.com',
  },
  {
    name: 'Real Estate',
    icon: realEstateIconImg,
    description: 'Track Properties & Sales.',
    adminLink: 'https://realestate.100billiontech.com/',
    staffLink: '#',
  },
  // {
  //   name: 'Sports',
  //   icon: sportsIconImg,
  //   description: 'Organize & Analyze Sports Data.',
  //   adminLink: 'https://admin.radicalsportsindia.com/',
  //   staffLink: 'http://staff.radicalsportsindia.com/',
  // },
];

const highlightMatch = (text, query) => {
  if (!query) return text;
  const regex = new RegExp(`(${query})`, 'gi');
  return text.replace(regex, '<mark>$1</mark>');
};

const Home = () => {
  const [search, setSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState('');
  const navigate = useNavigate();

  // ✅ Auto-redirect if user already selected a category and type
  useEffect(() => {
    const savedCategory = localStorage.getItem('selectedCategory');
    const userType = localStorage.getItem('userType');

    if (savedCategory && userType) {
      const category = categoryData.find(cat => cat.name === savedCategory);
      if (category) {
        const redirectLink =
          userType === 'admin' ? category.adminLink : category.staffLink;

        // Optional: add loading delay for smooth UX
        setTimeout(() => {
          window.location.href = redirectLink;
        }, 500);
      }
    }
  }, []);

  const matched = matchSorter(categoryData, search, { keys: ['name'] });

  let displayedCategories;
  if (search && matched.length > 0) {
    const topMatch = matched[0];
    displayedCategories = [
      topMatch,
      ...categoryData.filter(cat => cat.name !== topMatch.name),
    ];
  } else {
    displayedCategories = [
      categoryData.find(cat => cat.name === '100billion Tech'),
      ...categoryData.filter(cat => cat.name !== '100billion Tech'),
    ];
  }

  const handleLogin = (type) => {
    if (!selectedCategory) return;

    localStorage.setItem('selectedCategory', selectedCategory.name);
    localStorage.setItem('userType', type);

    const redirectLink =
      type === 'admin' ? selectedCategory.adminLink : selectedCategory.staffLink;

    setLoading(type);

    setTimeout(() => {
      window.location.href = redirectLink;
    }, 1000);
  };

  return (
    <div className="padding-bottom">
      <main className="home-page">
        <div className="home-header">
          <img
            src={mainImg}
            alt="100Billion Tech - OMS Platform Logo"
            className="home-header__logo"
          />
        </div>
      </main>

      <section className="home-content">
        {!selectedCategory && (
          <div className="home-content__intro">
            <h1 className="home-content__title">
              Power Your Workflow with <br />100billion OMS
            </h1>

            <div className="home-search-bar">
              <Search className="home-search-bar__icon" />
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search OMS, Ecommerce, Finance..."
                className="home-search-bar__input"
                aria-label="Search categories"
              />
            </div>
          </div>
        )}

        {!selectedCategory ? (
          <section className="home-categories">
            <div className="home-categories__list">
              {displayedCategories.map((category, index) => (
                <div
                  className="category-card"
                  key={index}
                  onClick={() => setSelectedCategory(category)}
                  style={{ cursor: 'pointer' }}
                >
                  <img
                    src={category.icon}
                    alt={`${category.name} icon`}
                    className="category-card__icon"
                  />
                  <h3
                    className="category-card__title"
                    dangerouslySetInnerHTML={{
                      __html: highlightMatch(category.name, search),
                    }}
                  />
                </div>
              ))}
            </div>
          </section>
        ) : (
          <section className="category-step">
            <h2 className="category-step__title">{selectedCategory.name}</h2>
            <p className="category-step__description">{selectedCategory.description}</p>

            <div className="category-step__actions">
              <p className="category-step__note">Admin access to manage operations.</p>
              <button
                className="btn-primary"
                onClick={() => handleLogin('admin')}
                disabled={loading === 'admin'}
              >
                {loading === 'admin' ? <Loader2 className="spinner" /> : 'Login as Admin'}
              </button>

              <p className="category-step__note">For internal staff members only.</p>
              <button
                className="btn-secondary"
                onClick={() => handleLogin('staff')}
                disabled={loading === 'staff'}
              >
                {loading === 'staff' ? <Loader2 className="spinner" /> : 'Login as Staff'}
              </button>

              <button className="btn-tertiary" onClick={() => setSelectedCategory(null)}>
                Selected wrong category? <span>Go Back</span>
              </button>

              <p className="category-step__desc">Fast. Secure. Reliable.</p>

              <button className="btn-outline" onClick={() => navigate('/contact')}>
                Contact Us
              </button>
            </div>
          </section>
        )}
      </section>
    </div>
  );
};

export default Home;
